const updateItems = [
  { time: '10分钟前', title: '某顶流男星深夜发文回应近期争议，态度强硬引发两极评价', tag: '最新' },
  { time: '28分钟前', title: '热播剧《某某传》编剧独家专访：第二季剧情走向曝光', tag: '独家' },
  { time: '1小时前', title: '知名综艺节目官宣新一季常驻嘉宾阵容，多位新面孔加盟', tag: '官宣' },
  { time: '2小时前', title: '头部带货主播选品团队被曝内部矛盾，核心成员离职', tag: '爆料' },
  { time: '3小时前', title: '某国际电影节公布入围名单，三部华语片成功入选', tag: '快讯' },
  { time: '5小时前', title: '知名音乐人发布新专辑预告，合作阵容豪华引期待', tag: '音乐' },
  { time: '7小时前', title: '网红城市文旅代言人选拔结果公布，争议人选引发热议', tag: '热议' },
  { time: '9小时前', title: '2026年度最具商业价值艺人榜单出炉，新生代强势崛起', tag: '榜单' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-3">
            <i className="ri-timer-flash-line text-sm"></i>
            最新动态
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            最新动态
          </h2>
          <p className="text-foreground-500 text-sm mt-2">7×24小时滚动更新，不错过任何热点</p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300 space-y-0">
            {updateItems.map((item, i) => (
              <div
                key={i}
                className="relative pb-8 last:pb-0 group cursor-pointer"
              >
                <div className="absolute -left-[29px] md:-left-[33px] top-1 w-4 h-4 rounded-full border-2 border-background-300 bg-background-50 group-hover:border-primary-500 group-hover:bg-primary-100 transition-colors"></div>
                <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4">
                  <span className="text-xs text-foreground-400 whitespace-nowrap flex-shrink-0">
                    {item.time}
                  </span>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-start gap-2">
                      <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 leading-snug group-hover:text-primary-600 transition-colors">
                        {item.title}
                      </h3>
                      <span className="flex-shrink-0 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                        {item.tag}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}